<motif-theme [variant]="themeVariant()"></motif-theme>
<router-outlet />
